import styled, { keyframes } from 'styled-components';

import {
	Container,
	GenericP,
	FlexDiv
} from 'commonStyles';
import { ASSET_PATH } from 'assetsPath';

const subImg = `${ASSET_PATH.IMAGES}landing/subModalBg.png`;

export const SubImwrap = styled(FlexDiv)`
	background-image: url(${subImg});
	background-size: cover;
	background-repeat: no-repeat;
	color: #fff;
	max-width: 200px;
	button {
		width: 100%;
		height: 45px;
		font-size: 16px;
		margin-bottom: 10px;
	}
`;
